import React, { Fragment, useState } from "react";
import DatePicker from "react-datepicker";
import { getQRCodeCountFilter } from "../../action/qrcode";
import Alert from "../layout/Alert";

const QRCodeFilter = ({
    setAlert,
}) => {
    const [startDateFilter, setStartDateFilter] = useState(undefined);
    const [endDateFilter, setEndDateFilter] = useState(undefined);
    const [showQRCodeResult, setShowQRCodeResult] = useState(false)
    const [totalQRCodeCount, setTotalQRCodeCount] = useState(0)

    function handleFilterReset() {
        setStartDateFilter("")
        setEndDateFilter("")
        setShowQRCodeResult(false)
        setTotalQRCodeCount(0)
    }

    function hanldeFilter() {
        if (!startDateFilter || startDateFilter==="") {
            setAlert("Invalid Start Date. Start Date Cannot be Empty", "danger")
            return
        }

        if (!endDateFilter || endDateFilter==="") {
            setAlert("Invalid End Date. End Date Cannot be Empty", "danger")
            return
        }

        let formmattedStartDate = formateDate(startDateFilter)
        let formattedEndDate = formateDate(endDateFilter)

        getQRCodeCountFilter({
            'startTs': formmattedStartDate,
            'endTs': formattedEndDate
        })
        .then((data)=>{
            setShowQRCodeResult(true)
            setTotalQRCodeCount(data.count)
        })
        .catch((err)=>{
            setShowQRCodeResult(false)
            setAlert(err?.response?.data?.message ?? err.message, "danger")
        })
    }

    const formateDate = (dateFilter) => {
        if (dateFilter) {
            const dateVal = dateFilter.getDate() < 10 ? `0${dateFilter.getDate()}` : dateFilter.getDate()
            const monthVal = dateFilter.getMonth() < 9 ? `0${dateFilter.getMonth() + 1}` : dateFilter.getMonth() + 1
            return `${dateVal}-${monthVal}-${dateFilter.getFullYear()}`
        }
    }

    return (
        <Fragment>
            <div className="content-block bottom-shadow" style={{ width: "100%", minWidth: 0 }}>
                <Alert />
                <div className="py-15 " style={{ width: "100%", minWidth: 0 }}>
                    <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 20, marginBottom: 20, justifyContent: "flex-start" }}>
                        <div style={{ display: "flex", alignItems: "center", flex: "0 0 auto", minWidth: 0 }}>
                            <div style={{ width: 140, flexShrink: 0 }}>
                                <DatePicker
                                    selected={startDateFilter}
                                    maxDate={new Date()}
                                    onChange={(date) => setStartDateFilter(date)}
                                    placeholderText="Start Date"
                                    dateFormat="MM/dd/yyyy"
                                    className="add-input calendar input_phone"
                                />
                            </div>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", flex: "0 0 auto", minWidth: 0 }}>
                            <div style={{ width: 140, flexShrink: 0 }}>
                                <DatePicker
                                    selected={endDateFilter}
                                    maxDate={new Date()}
                                    onChange={(date) => setEndDateFilter(date)}
                                    placeholderText="End Date"
                                    dateFormat="MM/dd/yyyy"
                                    className="add-input calendar input_phone"
                                />
                            </div>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: 14, flexShrink: 0 }}>
                            <button
                                className="btn btn-style-2 orange-bg"
                                onClick={hanldeFilter}
                                style={{ width: 140, minWidth: 140, height: 40, minHeight: 40, boxSizing: "border-box" }}
                            >
                                Filter
                            </button>
                            <button
                                className="btn btn-style-2 dark-text gray-bg"
                                onClick={handleFilterReset}
                                style={{ width: 140, minWidth: 140, height: 40, minHeight: 40, boxSizing: "border-box" }}
                            >
                                Reset
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {
                showQRCodeResult && <Fragment>
                    <div className="content-block position-relative">
                        <div className="reset-device-detail">
                            <div className="device-detail">
                                <div className="row">
                                    <div className="s12 col">
                                        <div className="unique-box mb-15">
                                            <label className="title d-inline min-180" style={{ fontSize: '14px' }}>Total QR Code Printed</label>
                                            <div className="device-info d-inline">
                                                {totalQRCodeCount}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment>
            }
        </Fragment>
    );
}

export default QRCodeFilter